import Position from './position'

const imagePath = './images/Player Icons/With Shadow/'
const formationPath = './images/Formation Images/'
export const defaultFormations = [
  {
    name: '4-3-3',
    description: '4-3-3',
    imageUrl: require(`${formationPath}4 - 3 - 3.jpg`)
  },
  {
    name: '4-2-3-1',
    description: '4-2-3-1',
    imageUrl: require(`${formationPath}4 - 2 - 3 - 1.jpg`)
  },
  {
    name: '5-3-2',
    description: '5-3-2',
    imageUrl: require(`${formationPath}5 - 3 - 2.jpg`),
    positions: [{
      x: '50%',
      y: '05%'
    }, {
      x: '10%',
      y: '35%'
    }, {
      x: '30%',
      y: '30%'
    }, {
      x: '50%',
      y: '30%'
    }, {
      x: '70%',
      y: '30%'
    }, {
      x: '90%',
      y: '35%'
    }, {
      x: '30%',
      y: '55%'
    }, {
      x: '50%',
      y: '55%'
    }, {
      x: '70%',
      y: '55%'
    }, {
      x: '40%',
      y: '80%'
    }, {
      x: '60%',
      y: '80%'
    }]
  },
  {
    name: '4-5-1',
    description: '4-5-1',
    imageUrl: require(`${formationPath}4 - 5 - 1.jpg`)
  },
  {
    name: '4-4-2',
    description: '4-4-2',
    imageUrl: require(`${formationPath}4 - 4 - 2.jpg`)
  },
  {
    name: '3-4-3',
    description: '3-4-3',
    imageUrl: require(`${formationPath}3 - 4 - 3.jpg`)
  },
  {
    name: '5-4-1',
    description: '5-4-1',
    imageUrl: require(`${formationPath}5 - 4 - 1.jpg`),
    positions: [{
      x: '50%',
      y: '05%'
    }, {
      x: '10%',
      y: '35%'
    }, {
      x: '30%',
      y: '30%'
    }, {
      x: '50%',
      y: '30%'
    }, {
      x: '70%',
      y: '30%'
    }, {
      x: '90%',
      y: '35%'
    }, {
      x: '20%',
      y: '55%'
    }, {
      x: '40%',
      y: '55%'
    }, {
      x: '60%',
      y: '55%'
    }, {
      x: '80%',
      y: '55%'
    }, {
      x: '50%',
      y: '80%'
    }]
  },
  {
    name: '3-5-2',
    description: '3-5-2',
    imageUrl: require(`${formationPath}3 - 5 - 2.jpg`)
  },
  {
    name: '4-3-2-1',
    description: 'Christmas tree',
    imageUrl: require(`${formationPath}4 - 3 - 2 - 1.jpg`)
  },
  {
    name: '4-1-2-1-2',
    description: '4-4-2 diamond',
    imageUrl: require(`${formationPath}4 - 1 - 2 - 1 - 2.jpg`)
  },
  {
    name: '3-3-3-1',
    description: '3-3-3-1',
    imageUrl: require(`${formationPath}3 - 3 - 3 - 1.jpg`)
  },
  {
    name: '3-4-1-2',
    description: '3-4-1-2',
    imageUrl: require(`${formationPath}3 - 4 - 1 - 2.jpg`)
  }
]

export const defaultPlayers = [
  {
    number: '1',
    firstName: 'Bernd',
    lastName: 'Leno',
    position: Position.GOALKEEPER,
    badgeUrl: require(`${imagePath}Bernd Leno.png`)
  },
  {
    number: '26',
    firstName: 'Emiliano',
    lastName: 'Martinez',
    position: Position.GOALKEEPER,
    badgeUrl: require(`${imagePath}Emiliano Martinez.png`)
  },
  {
    number: '33',
    firstName: 'Matt',
    lastName: 'Macey',
    position: Position.GOALKEEPER,
    badgeUrl: require(`${imagePath}Matt Macey.png`)
  },
  {
    number: '63',
    firstName: 'James',
    lastName: 'Hillson',
    position: Position.GOALKEEPER,
    badgeUrl: require(`${imagePath}James Hillson.png`)
  },
  {
    number: '2',
    firstName: 'Hector',
    lastName: 'Bellerin',
    position: Position.DEFENDER,
    badgeUrl: require(`${imagePath}Hector Bellerin.png`)
  },
  {
    number: '3',
    firstName: 'Kieran',
    lastName: 'Tierney',
    position: Position.DEFENDER,
    badgeUrl: require(`${imagePath}Kieran Tierney.png`)
  },
  {
    number: '5',
    firstName: '',
    lastName: 'Sokratis',
    position: Position.DEFENDER,
    badgeUrl: require(`${imagePath}Sokratis.png`)
  },
  {
    number: '16',
    firstName: 'Rob',
    lastName: 'Holding',
    position: Position.DEFENDER,
    badgeUrl: require(`${imagePath}Rob Holding.png`)
  },
  {
    number: '17',
    firstName: 'Cedric',
    lastName: 'Soares',
    position: Position.DEFENDER,
    badgeUrl: require(`${imagePath}Cedric Soares.png`)
  },
  {
    number: '20',
    firstName: 'Shkodran',
    lastName: 'Mustafi',
    position: Position.DEFENDER,
    badgeUrl: require(`${imagePath}Shkodran Mustafi.png`)
  },
  {
    number: '21',
    firstName: 'Calum',
    lastName: 'Chambers',
    position: Position.DEFENDER,
    badgeUrl: require(`${imagePath}Calum Chambers.png`)
  },
  {
    number: '22',
    firstName: 'Pablo',
    lastName: 'Mari',
    position: Position.DEFENDER,
    badgeUrl: require(`${imagePath}Pablo Mari.png`)
  },
  {
    number: '23',
    firstName: 'David',
    lastName: 'Luiz',
    position: Position.DEFENDER,
    badgeUrl: require(`${imagePath}David Luiz.png`)
  },
  {
    number: '31',
    firstName: 'Sead',
    lastName: 'Kolasinac',
    position: Position.DEFENDER,
    badgeUrl: require(`${imagePath}Sead Kolasinac.png`)
  },
  {
    number: '40',
    firstName: 'Tolaji',
    lastName: 'Bola',
    position: Position.DEFENDER,
    badgeUrl: require(`${imagePath}Tolaji Bola.png`)
  },
  {
    number: '49',
    firstName: 'Zech',
    lastName: 'Medley',
    position: Position.DEFENDER,
    badgeUrl: require(`${imagePath}Zech Medley.png`)
  },
  {
    number: '8',
    firstName: 'Dani',
    lastName: 'Ceballos',
    position: Position.MIDFIELDER,
    badgeUrl: require(`${imagePath}Dani Ceballos.png`)
  },
  {
    number: '10',
    firstName: 'Mesut',
    lastName: 'Ozil',
    position: Position.MIDFIELDER,
    badgeUrl: require(`${imagePath}Mesut Ozil.png`)
  },
  {
    number: '11',
    firstName: 'Lucas',
    lastName: 'Torreira',
    position: Position.MIDFIELDER,
    badgeUrl: require(`${imagePath}Lucas Torreira.png`)
  },
  {
    number: '15',
    firstName: 'Ainsley',
    lastName: 'Maitland-Niles',
    position: Position.MIDFIELDER,
    badgeUrl: require(`${imagePath}Ainsley Maitland-Niles.png`)
  },
  {
    number: '28',
    firstName: 'Joe',
    lastName: 'Willock',
    position: Position.MIDFIELDER,
    badgeUrl: require(`${imagePath}Joe Willock.png`)
  },
  {
    number: '29',
    firstName: 'Matteo',
    lastName: 'Guendouzi',
    position: Position.MIDFIELDER,
    badgeUrl: require(`${imagePath}Matteo Guendouzi.png`)
  },
  {
    number: '32',
    firstName: 'Emile',
    lastName: 'Smith-Rowe',
    position: Position.MIDFIELDER,
    badgeUrl: require(`${imagePath}Emile Smith-Rowe.png`)
  },
  {
    number: '34',
    firstName: 'Granit',
    lastName: 'Xhaka',
    position: Position.MIDFIELDER,
    badgeUrl: require(`${imagePath}Granit Xhaka.png`)
  },
  {
    number: '77',
    firstName: 'Bukayo',
    lastName: 'Saka',
    position: Position.MIDFIELDER,
    badgeUrl: require(`${imagePath}Bukayo Saka.png`)
  },
  {
    number: '9',
    firstName: 'Alexandre',
    lastName: 'Lacazette',
    position: Position.FORWARD,
    badgeUrl: require(`${imagePath}Alexandre Lacazette.png`)
  },
  {
    number: '14',
    firstName: 'Pierre-Emerick',
    lastName: 'Aubameyang',
    position: Position.FORWARD,
    badgeUrl: require(`${imagePath}Pierre-Emerick Aubameyang.png`)
  },
  {
    number: '19',
    firstName: 'Nicolas',
    lastName: 'Pepe',
    position: Position.FORWARD,
    badgeUrl: require(`${imagePath}Nicolas Pepe.png`)
  },
  {
    number: '24',
    firstName: 'Reiss',
    lastName: 'Nelson',
    position: Position.FORWARD,
    badgeUrl: require(`${imagePath}Reiss Nelson.png`)
  },
  {
    number: '30',
    firstName: 'Eddie',
    lastName: 'Nketiah',
    position: Position.FORWARD,
    badgeUrl: require(`${imagePath}Eddie Nketiah.png`)
  },
  {
    number: '35',
    firstName: 'Gabriel',
    lastName: 'Martinelli',
    position: Position.FORWARD,
    badgeUrl: require(`${imagePath}Gabriel Martinelli.png`)
  },
  {
    number: '43',
    firstName: 'Trae',
    lastName: 'Coyle',
    position: Position.FORWARD,
    badgeUrl: require(`${imagePath}Trae Coyle.png`)
  },
  {
    number: '45',
    firstName: 'Tyreece',
    lastName: 'John-Jules',
    position: Position.FORWARD,
    badgeUrl: require(`${imagePath}Tyreece John-Jules.png`)
  }
].map((x, index) => Object.assign({ id: index }, x))
